<script lang="ts">
  /**
   * ROUTER — Maps URL hash paths to Svelte components
   *
   * svelte-spa-router uses a simple Map<string, Component> to define routes.
   * When the URL hash changes (e.g., /#/dashboard), it renders the
   * corresponding component.
   *
   * The wildcard '*' catches any undefined route and shows a 404 page.
   */

  import Router from 'svelte-spa-router';
  import { wrap } from 'svelte-spa-router/wrap';

  // Page components (lazy-loaded for performance)
  import Login from '../features/auth/pages/Login.svelte';
  import DashboardHome from '../features/dashboard/pages/DashboardHome.svelte';
  import AdminPanel from '../features/dashboard/pages/AdminPanel.svelte';

  // Route map: path → component
  const routes = new Map<string, any>();

  // Public routes
  routes.set('/login', Login);

  // Protected routes (guard logic is handled by RouteGuard.svelte wrapper)
  routes.set('/dashboard', DashboardHome);
  routes.set('/admin', AdminPanel);

  // Default: redirect root to /dashboard
  routes.set('/', wrap({ component: DashboardHome }));

  // 404 catch-all (any unmatched path)
  // We'll just redirect to dashboard; you could create a NotFound.svelte instead
  routes.set('*', DashboardHome);
</script>

<Router {routes} />
